import React, { createContext, useContext, useReducer } from 'react';
import reducer, { initState } from './reducer';
import { TCtx, TReducer } from './types';

const initCtxValue: TCtx = [initState, () => {}];

const ctx = createContext<TCtx>(initCtxValue);

export const CtxWrapper: React.FC = ({ children }) => {
    const ctxValue = useReducer<TReducer>(reducer, initState);

    return <ctx.Provider value={ctxValue}>{children}</ctx.Provider>;
};

export const useCtx = () => {
    return useContext(ctx);
};
